(function(){
  'use strict';
  const core=window.MimosaChickCore;
  const money=(cents,currency)=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency||'USD'}).format((Number(cents)||0)/100);
  function init(root){
    const config=JSON.parse(root.querySelector('[data-mc-config]').textContent);
    const variants=config.variants;
    const variantInputs=[...root.querySelectorAll('[name="mc-variant"]')];
    const quantity=root.querySelector('[data-mc-quantity]');
    const minimumText=root.querySelector('[data-mc-minimum]');
    const total=root.querySelector('[data-mc-total]');
    const count=root.querySelector('[data-mc-count]');
    const error=root.querySelector('[data-mc-error]');
    const button=root.querySelector('[data-mc-submit]');
    const discount=root.querySelector('[data-mc-discount]');
    const checks=[...root.querySelectorAll('[data-mc-flavor]')];
    let variant=variants.find(item=>item.id===Number(root.querySelector('[name="mc-variant"]:checked').value))||variants[0];
    function selected(){return checks.filter(input=>input.checked).map(input=>input.value);}
    function render(){
      const qty=core.normalizeQuantity(quantity.value,variant.minimum);
      quantity.min=variant.minimum;
      quantity.value=qty;
      minimumText.textContent=`Minimum ${variant.minimum} guests`;
      total.textContent=money(variant.price*qty,config.currency);
      const state=core.validateSelection(selected(),variant.limit);
      count.textContent=`${selected().length} of ${variant.limit} selected`;
      checks.forEach(input=>{input.disabled=!input.checked&&selected().length>=variant.limit;});
      error.textContent=state.valid?'':state.remaining?`Select ${state.remaining} more flavor${state.remaining===1?'':'s'}.`:`Remove ${state.excess} flavor${state.excess===1?'':'s'}.`;
    }
    variantInputs.forEach(input=>input.addEventListener('change',()=>{
      variant=variants.find(item=>item.id===Number(input.value));
      checks.forEach(item=>{item.checked=false;item.disabled=false;});
      render();
    }));
    checks.forEach(input=>input.addEventListener('change',render));
    quantity.addEventListener('input',render);
    quantity.addEventListener('blur',render);
    root.querySelector('[data-mc-minus]').addEventListener('click',()=>{quantity.value=Number(quantity.value)-1;render();});
    root.querySelector('[data-mc-plus]').addEventListener('click',()=>{quantity.value=Number(quantity.value)+1;render();});
    fetch(`${window.Shopify.routes.root}cart.js`).then(response=>response.json()).then(cart=>{discount.hidden=!core.hasBloodyMary(cart);}).catch(()=>{});
    root.querySelector('[data-mc-form]').addEventListener('submit',async event=>{
      event.preventDefault();
      render();
      const flavors=selected();
      const state=core.validateSelection(flavors,variant.limit);
      if(!state.valid){error.scrollIntoView({behavior:'smooth',block:'center'});return;}
      button.disabled=true;
      button.textContent='Adding…';
      try{
        const qty=core.normalizeQuantity(quantity.value,variant.minimum);
        const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:qty,properties:core.buildProperties(flavors,qty)}]})});
        if(!response.ok){const result=await response.json();throw new Error(result.description||'Unable to add this product.');}
        window.location.href=`${window.Shopify.routes.root}cart`;
      }catch(reason){error.textContent=reason.message;button.disabled=false;button.textContent='Add to cart';}
    });
    render();
  }
  document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('[data-mimosa-chick]').forEach(init));
})();
